import '../styles/LandingLoanOfferingPanels.css';
import React from 'react';
import { ArrowRight } from 'lucide-react';

const PANELS = [
  {
    num: '01',
    title: 'Borrow with a clear picture',
    body: 'Montreaux is a consumer loan service for everyday applicants. Start by reading the offering on the Loans page, in plain language and without the bank-counter tone.',
    tag: 'Start here',
  },
  {
    num: '02',
    title: 'Read each term, one at a time',
    body: 'The loan information is laid out as modular panels, so each term sits on its own and can be read at your own pace before you decide anything.',
    tag: 'Loan information',
  },
  {
    num: '03',
    title: 'Apply when it feels right',
    body: 'When the offering matches your need, send a request on the Apply page. No account, no sign-in — just your details and the loan purpose.',
    tag: 'Application',
  },
];

function LandingLoanOfferingPanels() {
  return (
    <section className="lop-panels" aria-labelledby="lop-heading">
      <div className="lop-rail" data-content-rail="primary">
        <h2 className="lop-sr-only" id="lop-heading">What Montreaux lends</h2>
        <div className="lop-kicker">
          <span className="lop-kicker-label">The offering</span>
          <span className="lop-kicker-rule" aria-hidden="true" />
          <span className="lop-kicker-meta">Three ways into the loan information</span>
        </div>

        <ul className="lop-grid">
          {PANELS.map((panel) => (
            <li className="lop-panel-item" key={panel.num}>
              <a className="lop-panel" href="/loans" aria-label={`${panel.title} — read the loan information on the Loans page`}>
                <div className="lop-panel-head">
                  <span className="lop-num" aria-hidden="true">{panel.num}</span>
                  <span className="lop-tag">{panel.tag}</span>
                </div>
                <h3 className="lop-title">{panel.title}</h3>
                <p className="lop-copy">{panel.body}</p>
                <span className="lop-foot">
                  Read on Loans
                  <ArrowRight className="lop-arrow" size={16} strokeWidth={1.75} aria-hidden="true" />
                </span>
              </a>
            </li>
          ))}
        </ul>

        <p className="lop-more">
          <span>Prefer to read it all together?</span>
          <a className="lop-more-link" href="/loans">
            Open the Loans page
            <ArrowRight className="lop-arrow" size={15} strokeWidth={1.75} aria-hidden="true" />
          </a>
        </p>
      </div>
    </section>
  );
}

export default LandingLoanOfferingPanels;